import apiJson from "../config/api-json";
import {RqErrorLog} from "./dto/RqErrorLog";
import {getUserInfo} from "./APIUtils";

export class ErrorAPI {

    baseUrl = "/webview/error"

    async sendErrorLog(error: Error, url: string, verificationId: string) {
        const token = localStorage.getItem("next-step")
        const config = await getUserInfo(verificationId, token)
        const errorPayload = new RqErrorLog(
            error.message,
            verificationId,
            url
        )
        await apiJson.post(this.baseUrl, errorPayload, config)
    }

}